module.exports = __webpack_public_path__ + "static/media/academic-chair.516ee87b.webp";